import React from "react";
import { Link } from "react-router-dom";
import "../../Styles/Feefrequency.css";

export default function VehicleAccessoryDetail1() {
  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Accessory Details</h4>
        <div className="yc-header-actions">
          <Link to="/updatevehiclefine" className="btn btn-primary">Edit</Link>
          <button type="button" className="btn btn-danger">Delete</button>
        </div>
      </div>

      <div className="ff-page-body">
        <div className="card ff-detail-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table ff-detail-table mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold ff-detail-label">Vehicle Name</td>
                    <td>Safe Student</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Accessory Item</td>
                    <td>Side Mirror</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Quantity</td>
                    <td>23</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Price</td>
                    <td>$1000</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Purchase From</td>
                    <td>Shop</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Purchase Date</td>
                    <td>Thu Mar 3 2022</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Invoice</td>
                    <td>View Invoice</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
